import styled from "styled-components";

const ProductImageContainer = styled.div`
    > a {
        min-height: 300px;
        &:not(.loaded) {
            background-color: #efefef;
        }
    }
`;

export default ProductImageContainer;
